
import * as vercelRuntime$crq5603kVmqvq7ENFehvLNOnOy_a4rzNi1LJzispeWo from '/vercel/path0/node_modules/.pnpm/@nuxt+image@1.10.0_@azure+cosmos@4.4.1_@azure+identity@4.10.0_aws4fetch@1.0.20_db0@0.3.2_ioredis@5.6.1_magicast@0.3.5/node_modules/@nuxt/image/dist/runtime/providers/vercel'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "vercel",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['vercel']: { provider: vercelRuntime$crq5603kVmqvq7ENFehvLNOnOy_a4rzNi1LJzispeWo, defaults: {} }
}
        